/* eslint-disable no-console */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-param-reassign */
const processYourInfoPage = (submissionVM, props) => {
    props.baseData = submissionVM.baseData.value;
    props.coverageType = submissionVM.lobData.homeowners.coverables.coveragePartType_ML.value.code;
    return props;
}

const processQualificationPage = (submissionVM, props) => {
    props.preQualQuestionSets = submissionVM.value.lobData.homeowners.preQualQuestionSets[0]; 
    props.dwellingAdditionalInfo = submissionVM.value.lobData.homeowners.dwellingAdditionalInfo[0];
    return props;
}

const processDiscountPage = (submissionVM, props) => {
    props.discounts = submissionVM.value.lobData.homeowners.modifiers_ML; 
    return props;
};

const processAdditionalInfoPage = (submissionVM, props) => {
    props.priorInsurance = submissionVM.value.lobData.homeowners.priorInsurance[0];
    props.dwellingQuestionSet = submissionVM.value.lobData.homeowners.dwellingAdditionalInfo[0];
    return props;
};

const processConstructionPage = (submissionVM, props) => {
    props.constructionVeriskDetails = submissionVM.lobData.homeowners.coverables.constructionVeriskDetails_ML.value;
    props.constructionDetails = submissionVM.lobData.homeowners.coverables.constructionDetails_ML.value;
    return props;
};

const processDisclosurePage = (submissionVM, props) => {
    props.disclosures = submissionVM.lobData.homeowners.value.coverables.disclosures_ML.losses.reduce((acc, disclosure, index) => {
        acc[`disclosure${index + 1}`] = disclosure;
        return acc;
    }, {});
    return props;
};

const processQuotePage = (submissionVM, props) => {

    const reduceCoverages = (coverages) => {
        if (coverages.length == 0){
            return {};
        }
        return coverages.reduce((acc, coverage, index) => {
            if (coverage?.selected == true && coverage?.hasTerms == true) {
                acc[`coverage${index+1}`] = {
                    name: coverage.name,
                    terms: coverage?.terms.reduce((innerAcc, term) => {
                        if (term?.isVisible_ML == true) {
                            innerAcc[term.name] = {
                                chosenTermValue: term?.chosenTermValue
                            };
                        }
                        return innerAcc;
                    }, {})
                };
            }
            return acc;
        }, {});
    };

    const reduceScheduledProperties  = (properties) => {
        if (properties.length == 0){
            return {};
        }
        return properties.reduce((acc, property, index) => {
            acc[`property${index+1}`] = {
                itemType: property.type.chosenTermValue,
                deductible: property.deductible.chosenTermValue,
                lossSettlement: property.lossSettlement.chosenTermValue,
                itemValue: property.itemValue
            };
            return acc;
        }, {});
    };

    const reduceValuableProperties  = (properties) => {
        if (properties.length == 0){
            return {};
        }
        return properties.reduce((acc, property, index) => {
            acc[`property${index+1}`] = {
                itemType: property.type.chosenTermValue,
                perItemLimit: property.perItemLimit.chosenTermValue,
                totalLimit: property.aggregateLimit.chosenTermValue
            };
            return acc;
        }, {});
    };

    const coverages = submissionVM.value.lobData.homeowners.offerings[0].coverages;
    
    props.additionalCoverages = reduceCoverages(coverages?.additionalCoverages);
    props.optionalCoverages = reduceCoverages(coverages?.optionalCoverages_ML);
    props.baseCoverages = reduceCoverages(coverages?.baseCoverages);
    props.exclusionCoverages = reduceCoverages(coverages?.exclusionCoverages_ML);
    props.conditionCoverages = reduceCoverages(coverages?.conditionCoverages_ML);
    props.offering = submissionVM.value.quoteData.offeredQuotes[0];
    props.replacementCost = coverages?.replacementCost_ML;
    props.schedulePersonalProperties = reduceScheduledProperties(coverages?.schedulePersonalProperties_ML)
    props.valuablePersonalProperties = reduceValuableProperties(coverages?.valuablePersonalProperties_ML)

    return props;
};

const getCoveragePackageLevel = (submission) => {
    if (!submission.bindData?.value?.chosenQuote) {
        return undefined
    }

    const chosenQuote = submission.quoteData.value.offeredQuotes.find((offering) => {
        return offering.publicID === submission.bindData.value.chosenQuote
    });

    return chosenQuote.coveragePackageLevel_Ext;
}

const HOTrackEvent = (eventName, isSkipping, submissionVM, user, props, isQnB) => {
    try {
        if (eventName === 'Quote Step Submitted' || eventName === 'Issuance Step Submitted' ) {
            sessionStorage.setItem('userSubmitAction', true);
            sessionStorage.setItem('userSubmitted', new Date());
            if (!isSkipping && sessionStorage.getItem('pageLoaded')) {
                const pageLoadTime = new Date(sessionStorage.getItem('pageLoaded'));
                const userSubmitTime = new Date();
                props.user_spent_time = (userSubmitTime - pageLoadTime) / 1000;
                sessionStorage.setItem('lastAction', props.action);
            }
        }
        if (eventName === 'Quote Step Reached' || eventName === 'Issuance Step Reached' || eventName === 'Quote Purchased' ) {
            if (!isSkipping) {
                sessionStorage.setItem('pageLoaded', new Date());
                if (sessionStorage.getItem('userSubmitAction') && sessionStorage.getItem('userSubmitted')) {
                    const userSubmitTime = new Date(sessionStorage.getItem('userSubmitted'));
                    const pageLoadTime = new Date();
                    props.system_load_time = (pageLoadTime - userSubmitTime) / 1000;
                    sessionStorage.setItem('userSubmitAction', false);
                    sessionStorage.setItem('lastStep', props.step);
                }
            }
        }
        if (props.step == 'Your Info HO Page' || props.action == 'Your Info Page HO Submitted') {
            props = processYourInfoPage(submissionVM, props);
        }
        if (props.step == 'Qualification Page' || props.action == 'Qualification Page Submitted' || props.step == 'Gateway CompRater HO Validation Page' || props.action == 'CompRater Home Validation Page Submitted') {
            props = processQualificationPage(submissionVM, props);
        }
        if (props.step == 'Construction Page' || props.action == 'Construction Page Submitted') {
            props = processConstructionPage(submissionVM, props);
        }
        if (props.step == 'Discount Page' || props.action == 'Discount Page Submitted' || props.step == 'Gateway CompRater HO Validation Page' || props.action == 'CompRater Home Validation Page Submitted') {
            props = processDiscountPage(submissionVM, props);
        }
        if (props.step == 'HO Additional Info Page' || props.action == 'HO Additional Page Submitted' || props.step == 'Gateway CompRater HO Validation Page' || props.action == 'CompRater Home Validation Page Submitted') {    
            props = processAdditionalInfoPage(submissionVM, props);
        }
        if (props.step == 'HO Disclosure Page' || props.action == 'HO Disclosure Page Submitted') {
            props = processDisclosurePage(submissionVM, props);
        }
        if (props.step == 'Quote Page' || props.action == 'Quote Submitted') {
            props = processQuotePage(submissionVM, props);
        }
        props.quote_type = sessionStorage.getItem('quoteType');
        props.pol_state = submissionVM.baseData.value.policyAddress.state;
        if (!isQnB) {
            props.user_type = user.userTypeName_ML;
            props.agent_id = user.userName_ML;
        }
        if (submissionVM.lobData.homeowners.priorInsurance.value !== undefined)
        {
            if (submissionVM.lobData.homeowners.priorInsurance.value[0].
                answers.MultLineCurrentInsuranceProvider_Ext != null ) {
                props.prior_insurance_carrier = submissionVM.lobData.homeowners.priorInsurance.value[0].
                    answers.MultLineCurrentInsuranceProvider_Ext.replace('MultLineCurrentInsuranceProvider','');}}
        props.isPFMReturned = submissionVM.baseData.isPFMReturned_ML.value;
        props.home_subtype = submissionVM.lobData.value.homeowners.coverables.coveragePartType_ML;
        props.pfm_no_hit = submissionVM.baseData.pfmLevel_ML.value === ('NF'||'NK'||'NN'||'NQ') ? true :undefined ;
        props.gpc_code = submissionVM.baseData.value.gafInfo_ML !== undefined ? submissionVM.baseData.value.gafInfo_ML.gpcCode : undefined ;
        if (!props.gpc_code && !_.isEmpty(sessionStorage.getItem('gpcCode'))) { 
            props.gpc_code = sessionStorage.getItem('gpcCode');
        }
        props.app_name = (isQnB) ? 'Quote and Buy' : 'Producer Engage';
        props.app_parent = 'Agent360';
        props.lob = 'Home';
        props.quote_publicId = submissionVM.quotePublicId.value;
        props.isCompRater = submissionVM.hvqDiscrepancies_ML.value !== undefined ;
        props.compRaterVendorName = _.get(submissionVM, 'compRaterVendorName_ML.value', '');
        props.quoteID = submissionVM.quoteID?.value;
        props.bundleIndicator = (submissionVM.isBundle_ML && submissionVM.isBundle_ML.value) || (isQnB && sessionStorage.getItem('IsBundle') === 'true') ? 'Y': 'N';
        props.qnb_source_id = submissionVM.baseData?.directConsumerSource_Ext?.value;

        window.analytics.track(eventName, props);

        if (eventName === 'Quote Step Reached' || eventName === 'Issuance Step Reached' || eventName === 'Quote Purchased' ) {
            const pageProps = {
                state: props.pol_state,
                lob: props.lob,
                priorCarrier: (props.prior_insurance_carrier) ? props.prior_insurance_carrier : undefined,
                bundleIndicator: props.bundleIndicator,
                producerCode: submissionVM.producerCodeOfRecord_ML.code?.value,
                zip: submissionVM.baseData.value.policyAddress.postalCode,
                pfm: submissionVM.baseData.value.pfmLevel_ML,
                productType: getCoveragePackageLevel(submissionVM),
                quoteID: props.quoteID,
                isCompRater: props.isCompRater,
                offering: props?.offering,
                home_subtype : props?.home_subtype 
            };

            const category = (eventName === 'Quote Step Reached') ? 'Quote Page' : 'Issuance Page';

            window.analytics.page(category, props.step, pageProps);

            if (!isQnB) {
                try {
                    window.analytics.identify(user.userName_ML, {
                        name: user.displayName,
                        email: user.email,
                        producercode: user.primaryProducerCode_ML?.code,
                        userType: user.userTypeName_ML,
                        pc_username: user.userName_ML,
                        groupName: user.affiliatedGroup_ML?.groupName,
                        login : user.loginID,
                        IAPortalId: user.portalId,
                        pol_state: props.pol_state,
                        lob: props.lob,
                        coveragePartType: props?.home_subtype,
                        isCompRater: props.isCompRater ,
                        quoteID: props.quoteID,                    bundleIndicator: props.bundleIndicator,
                        app_page: props.step,
                        Agent_Segment: user.primaryProducerCode_ML?.producerLevel,
                        Transaction_Type: eventName,
                        PolicyNumber: undefined,
                        PolicyNumbers: undefined,
                        lobs: undefined,
                        pol_states: undefined
                    });
                } catch (e) {
                    console.error(`Segment error calling identify API: ${e.message}`);
                }
            }
        }

        sessionStorage.setItem('segmentProps', JSON.stringify(props));
    
    } catch (e) {
        console.error(`Segment Error in HO Track Event: ${e.message}`);

    }
};

export default HOTrackEvent ;